import { useTranslation } from 'react-i18next';

import type { InvoiceStatus } from '~/api/invoices/types';
import type { IconName } from '~/components';
import type { statusColorThemes } from '~/styles/themes.css';

import { StatusTag } from '~/components';

type StatusEntry = {
  icon: IconName;
  status: keyof typeof statusColorThemes;
};

const statusMap: Record<InvoiceStatus, StatusEntry> = {
  InReview: { icon: 'HourglassTop', status: 'warning' },

  Approved: { icon: 'Check', status: 'discovery' },
  CoPaid: { icon: 'Check', status: 'success' },
  FcPaid: { icon: 'Check', status: 'success' },

  Expired: { icon: 'HourglassBottom', status: 'danger' },

  Draft: { icon: 'Edit', status: 'neutral' },
  LockedByUser: { icon: 'Edit', status: 'neutral' },
  Credited: { icon: 'CreditNote', status: 'neutral' },
};

type Props = {
  status: InvoiceStatus;
};

export const InvoiceStatusTag = ({ status }: Props) => {
  const { icon, status: statusTheme } = statusMap[status];
  const { t } = useTranslation(['invoices']);

  return <StatusTag icon={icon} label={t(`invoices:overview.columns.status.options.${status}`)} status={statusTheme} />;
};
